module.exports = __webpack_public_path__ + "img/dashboard-icon-green.bb2c62c9.svg";